import { MACROTREND_EVALUATION } from '../types'

export const OUT_OF_SCOPE = 'OUT_OF_SCOPE'
export const ALL = 'ALL'
export const ACT = 'ACT'
export const PREPARE = 'PREPARE'
export const WATCH = 'WATCH'
export const RECOMMENDATIONS = [ACT, PREPARE, WATCH]

export const RECOMMENDED_ACTION = 'recommendedAction'

export const RECOMMENDED_ACTIONS_TEXT = {
    [ACT]: ACT,
    [PREPARE]: PREPARE,
    [WATCH]: WATCH,
    [OUT_OF_SCOPE]: 'OUT OF SCOPE'
}

export const RECOMMENDED_ACTIONS = [...RECOMMENDATIONS, OUT_OF_SCOPE]
export const ACTIONS = [ACT, PREPARE, WATCH]

export const defaultCount = {
    [ACT]: 0,
    [PREPARE]: 0,
    [WATCH]: 0,
    [OUT_OF_SCOPE]: 0
}

const isValidRecommendedAction = (evaluation) => {
    return evaluation && evaluation.recommendedAction && RECOMMENDED_ACTIONS.includes(evaluation.recommendedAction)
}

export const buildRecommendationData = (evaluations) => {
    const initialCount = { ...defaultCount }

    if (evaluations && evaluations.length > 0) {
        return evaluations.reduce(
            (recommendedActionCount, evaluation) => {
                const validateEvaluation =
          evaluation.__typename === MACROTREND_EVALUATION
              ? evaluation.evaluation
              : (
                  evaluation.overrideEvaluation
                      ? evaluation.overrideEvaluation
                      : evaluation.averageEvaluation
              )

                if (isValidRecommendedAction(validateEvaluation)) {
                    recommendedActionCount[validateEvaluation.recommendedAction]++
                }

                return recommendedActionCount
            },
            initialCount
        )
    }

    return initialCount
}
